import React from 'react';
import Typewriter from '../components/Typewriter';

function Home() {
  return (
    <section id="home" className="bg-home shadow-lg">
      <div className="bg-home-hover p-5">
        <div className="container my-5 py-5">

          <div className='row justify-content-center'>
            <div className='col-md-8 text-center py-5'>
              <img className='img-profile mb-5' src='img/roccomacellaro.jpeg' alt='Rocco Macellaro' />
              <h1 className="big">Hi, I'm Rocco Macellaro</h1>
              <div>
                <h4>
                  <Typewriter texts={['Software Designer', 'Full Stack Developer', 'Amateur Photographer']} speed={50}  />
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;